import React, { useEffect } from 'react';
import { ConfigProvider, App as AntApp } from 'antd';
import { BrowserRouter as Router, useLocation } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';

import AppRoutes from './Routes';
import GlobalStyle from './GlobalStyle';
import { AuthProvider, useAuth } from './contexts/AuthContext';
import { trackPageView } from './utils/analytics';

function AppContent() {
  const { loading } = useAuth();
  const location = useLocation();

  // Track page views on route changes (SPA navigation)
  useEffect(() => {
    trackPageView(location.pathname + location.search, document.title);
  }, [location]);

  if (loading) return null;

  return <AppRoutes />;
}

function App() {
  useEffect(() => {
    const checkForUpdates = async () => {
      try {
        const response = await fetch(`/version.json?t=${Date.now()}`, {
          cache: 'no-cache',
          headers: { 'Cache-Control': 'no-cache', 'Pragma': 'no-cache' },
        });
        if (response.ok) {
          const data = await response.json();
          const currentVersion = localStorage.getItem('app-version');
          if (currentVersion && currentVersion !== data.version) {
            if ('caches' in window) {
              caches.keys().then(names => names.forEach(n => caches.delete(n)));
            }
            localStorage.setItem('app-version', data.version);
            window.location.reload();
          } else if (!currentVersion) {
            localStorage.setItem('app-version', data.version);
          }
        }
      } catch (e) {
        console.log('Version check failed:', e);
      }
    };

    const t = setTimeout(checkForUpdates, 5000);
    const i = setInterval(checkForUpdates, 3 * 60 * 1000);
    return () => { clearTimeout(t); clearInterval(i); };
  }, []);

  return (
    <HelmetProvider>
      <ConfigProvider>
        <AntApp>
          <Router>
            <GlobalStyle />
            <AuthProvider>
              <AppContent />
            </AuthProvider>
          </Router>
        </AntApp>
      </ConfigProvider>
    </HelmetProvider>
  );
}

export default App;
